/// <reference path="../typings/Dapi.d.ts" />
/// <reference path="../typings/IContextAction.ts" />
/// <reference path="../typings/IResourceEvent.ts" />
/// <reference path="../typings/index.d.ts" />
/// <reference path="../typings/material-components-web.d.ts" />
import '../styles/cloudcenter.css';
import '../styles/subscriptionWizardV2.css';
import '../styles/appview.css';
import {OrganizationList} from "./organizationList";
import {Tenant} from "./tenant";
import {PermissionManagement} from "./permissionManagement";
import "./stringhelpers";
import {AppEdit} from "./appEdit";
import {AppList} from "./appList";
import {OrganizationEdit} from "./organizationEdit";
import {ProviderList} from "./providerList";
import {ProviderEdit} from "./providerEdit";
import {ProviderOverview} from "./providerOverview";
import {ProviderMembership} from "./providerMembership";
import {App} from "./app";
import {ConfigTerms} from "./configTerms";
import {OrderWizard} from "./orderWizard";
import {OrderWizardLandingPage} from "./orderWizardLandingPage";
import {SubscriptionWizardV2} from "./subscriptionWizardV2";
import {SubscriptionWizardV2LandingPage} from "./subscriptionWizardV2LandingPage";
import {OrganizationV2} from "./organizationV2";
import {TenantMove} from "./tenantMove";
import {TenantOverwrites} from "./tenantOverwrites";

export class CloudCenter{
    private resource: Object;

    constructor() {
        this.resource = this.instantiateResource(document.body.getAttribute('data-resource'));
    }

    private instantiateResource(resourceClass: string): Object {
        switch(resourceClass) {
            case "organizationV2": return new OrganizationV2();
            case "organizationList": return new OrganizationList();
            case "organizationEdit": return new OrganizationEdit();
            case "permissionManagement": return new PermissionManagement();
            case "tenant": return new Tenant();
            case "tenantOverwrites": return new TenantOverwrites();
            case "tenantMove": return new TenantMove();
            case "app": return new App();
            case "appEdit": return new AppEdit();
            case "appList": return new AppList();
            case "providerList": return new ProviderList();
            case "providerEdit": return new ProviderEdit();
            case "providerOverview": return new ProviderOverview();
            case "providerMembership": return new ProviderMembership();
            case "configTerms": return new ConfigTerms();
            case "orderWizard": return new OrderWizard();
            case "orderWizardLandingPage": return new OrderWizardLandingPage();
            case "subscriptionWizardV2": return new SubscriptionWizardV2();
            case "subscriptionWizardV2LandingPage": return new SubscriptionWizardV2LandingPage();
            default:
                console.warn(`${window.location.href} contains the 'data-resource' tag '${resourceClass}' but no typescript class is mapped to this value. Perhaps you did forget to map this value?`);
                return null;
        }
    }
}
var cloudCenter = new CloudCenter();